import '../node_modules/bootstrap/dist/css/bootstrap.min.css'
import '../node_modules/bootstrap/dist/js/bootstrap.bundle.js'
import './App.css';
import { Routes, Route, Link, useNavigate, useLocation } from "react-router-dom";
import RouteGuard from './components/route-guard/route-guard.component'
import { API_CONSTANTS, APP_CONSTANTS, ROUTES } from './utils/AppConstants'
import BusinessCreateAccount from './pages/account/business-create-account/businessCreateAccount.js'
import LandingPage from './pages/landing/landing-page/landingPage.js'
import ContactUsPage from './pages/landing/contact-us/contactUs.js'
import FeaturePage from './pages/landing/feature-page/featurePage.js'
import PricingPage from './pages/landing/pricing-page/pricingPage.js'
import BusinessLogin from './pages/account/business-login/businessLogin.js'
import { useSelector, useDispatch } from 'react-redux';
import CustomSidebar from './components/sidebar/sidebar.component';
import PrivacyPolicyPage from './pages/privacy-policy/privacyPolicyScreen'
import CookiePolicyScreen from './pages/cookie-policy/cookiePolicyScreen'
import UpdateProfile from './pages/account/update-profile/updateProfile'
import BusinessDashboard from './pages/dashboard/business-dashboard/businessDashboard.js'
import EmployeeDashboard from './pages/dashboard/employee-dashboard/employeeDashboard.js'
import EmployeeLogin from './pages/account/employee-login/employeeLogin.js'
import MenuPage from './pages/menu-page/menuPage'
import EmployeeList from './pages/employee/employee-list/employeeList.js'
import AddEmployee from './pages/employee/add-employee/addEmployee.js'
import EmployeeDetail from './pages/employee/employee-detail/employeeDetail.js'
import AttendanceList from './pages/employee/attendance-list/attendanceList.js'
import ProjectList from './pages/project/project-list/projectList.js'
import AddProject from './pages/project/add-project/addProject.js'
import ProjectDetail from './pages/project/project-detail/projectDetail.js'
import ShiftList from './pages/shift/shift-list/shiftList.js'
import AddShift from './pages/shift/add-shift/addShift.js'
import ShiftDetail from './pages/shift/shit-detail/shiftDetail.js'
import TaskList from './pages/task/task-list/taskList.js'
import AddTask from './pages/task/add-task/addTask.js'
import TaskDetail from './pages/task/task-detail/taskDetail.js'
import RequestList from './pages/request/request-list/requestList.js'
import AddRequest from './pages/request/add-request/addRequest.js'
import EmployeeRequestList from './pages/request/employee-request-list/employeeRequestList.js'
import DocumentList from './pages/document/document-list/documentList.js'
import AddDocument from './pages/document/add-document/addDocument.js'
import MessageChatList from './pages/message/message-chat-list/messageChatList.js'
import MessageList from './pages/message/message-list/messageList.js'
import PolicyList from './pages/policy/policy-list/policyList.js'
import AddPolicy from './pages/policy/add-policy/addPolicy.js'
import PolicyDetail from './pages/policy/policy-detail/policyDetail.js'
import ForgotPassword from './pages/account/forgot-password/forgotPassword.js'
import EmployeeSelectLocation from './pages/account/employee-select-location/employeeSelectLocation.js'
import EmployeeChangePassword from './pages/account/employee-change-password/employeeChangePassword.js'
import NotFoundPage from './pages/not-found/notFoundPage.js'
import AdminUserList from './pages/admin/users/user-list/userList.js'
import AdminContactUsList from './pages/admin/contact-us/contact-us-list/contactUsList.js'
import AdminSubscriptionList from './pages/admin/subscription/subscription-list/subscriptionList.js'
import AdminAddSubscription from './pages/admin/subscription/add-subcription/addSubscription.js'
import LocationListScreen from './pages/account/location/location-list/locationList.js'
import AddLocationScreen from './pages/account/location/add-location/addLocation.js'
import EditLocationScreen from './pages/account/location/edit-location/editLocationScreen.js'
import BusinessListScreen from './pages/account/business/business-list/business-list.js'
import AddBusinessScreen from './pages/account/business/add-business/addBusiness.js'
import AssetsList from './pages/assets/assets-list/assetsList.js'
import AddAssets from './pages/assets/add-assets/addAssets.js'
import AssetDetails from './pages/assets/asset-detail/assetDetail.js'
import PeformanceMenuScreen from './pages/performance/performance-menu-screen/performanceMenuScreen.js'
import PerformanceRequestList from './pages/performance/performance-request-list/performanceRequestList.js'
import PerformanceNewRequest from './pages/performance/performance-new-request/performanceNewRequest.js'
import PerformanceGoalList from './pages/performance/performance-goal-list/performanceGoalList.js'
import PerformanceAddGoal from './pages/performance/performance-add-goal/performanceAddGoal.js'
import PerformanceReviewList from './pages/performance/performance-review-list/performaceReviewList.js'
import PerformanceGoalDetail from './pages/performance/performance-goal-detail/performanceGoalDetail.js'
import EmployeeClockIn from './pages/employee/employee-clock-in/employeeClockIn.js'
import SubscriptionRenewScreen from './pages/account/subscription-renew-screen/subscriptionRenewScreen.js'
import AuditList from './pages/audit/audit-list/auditList.js'
import NewAudit from './pages/audit/new-audit/newAudit.js'
import AuditDetail from './pages/audit/audit-detail/auditDetail.js'
import VisitorOptionMenu from './pages/visitor/option-menu/optionMenu.js'
import VisitorSettingScreen from './pages/visitor/visitor-setting-screen/visitorSettingScreen.js'
import VisitorBook from './pages/visitor/visitor-book/visitorBook.js'
import VisitorQrCode from './pages/visitor/visitor-qr-code/visitorQrCode.js'
import VisitorCheckIn from './pages/visitor/visitor-check-in/visitorCheckIn.js'
import PayrollMenu from './pages/payroll/payroll-menu/payrollMenu.js'
import TaxRuleList from './pages/payroll/tax-rule-list/taxRuleList.js'
import PayslipList from './pages/payroll/payslip-list/payslipList.js'
import NewPayslip from './pages/payroll/new-payslip/newPayslip.js'
import PayslipDetail from './pages/payroll/payslip-detail/payslipDetail.js'
import SuppliesMenu from './pages/supplies/supplies-menu/suppliesMenu.js'
import MerchantList from './pages/supplies/merchant-list/merchatList.js'
import AddMerchant from './pages/supplies/add-merchant/addMerchant.js'
import MerchantDetail from './pages/supplies/merchant-detail/merchantDetail.js'
import SuppliesCategoriesList from './pages/supplies/supplies-categories-list/suppliesCategoriesList.js'
import SuppliesCatList from './pages/supplies/supplies-cat-list/suppliesCatList.js'
import SuppliesItemList from './pages/supplies/supplies-item-list/suppliesItemList.js'
import AddSuppliesItem from './pages/supplies/add-supplies-item/addSuppliesItem.js'
import SuppliesItemDetail from './pages/supplies/supplies-item-detail/suppliesItemDetails.js'
import { updateUserNotificationTokenRequest, updateUserNotificationTokenRequestStatus, updateSelectedLocation } from './redux/user/user.action.js'
import { useEffect, useState } from 'react';
import Select, { components } from 'react-select'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserCustomer, isLoggedInUserBusiness, isNull } from './utils/Utils.js';
import TermsConditionScreen from './pages/terms-condition/termsConditionScreen.js'

function App() {
  const { isLogin, displaySideBar, user, updateNotificationTokenSuccess,
    updateNotificationTokenError, updateNotificationTokenReqStatus, showMenuOption,
    commonError
  } = useSelector((state) => state.user)
  const dispatch = useDispatch()
  let navigate = useNavigate();
  const DEFAULT_LOCATION = { key: APP_CONSTANTS.DEFAULT_LOCATION_KEY, name: 'USA', img: require('./assets/flag/usa_flag.png') }
  const [countryLabel, setCountryLabel] = useState('')
  const [selectedLocation, setSelectedLocation] = useState(DEFAULT_LOCATION)
  const LOCATION_LIST = [
    { key: 'USA', name: 'USA', img: require('./assets/flag/usa_flag.png') },
    { key: 'CANADA', name: 'Canada', img: require('./assets/flag/canada_flag.png') },
    { key: 'INDIA', name: 'India', img: require('./assets/flag/india_flag.png') },
    { key: 'AUSTRALIA', name: 'Australia', img: require('./assets/flag/australia_flag.png') }
  ]

  useEffect(() => {
    setSelectedLocation({
      value: DEFAULT_LOCATION.key,
      label: DEFAULT_LOCATION.name,
      data: DEFAULT_LOCATION,
    })
    dispatch(updateSelectedLocation(DEFAULT_LOCATION))
  }, [])

  const Option = (props) => {
    return (
      <components.Option {...props}>
        <div className='select-row-container'>
          <div className='select-img-container'>
            <img src={props.data.data.img} alt={props.data.name} className='img' />
          </div>
          {props.data.data.name}
        </div>
      </components.Option>
    )
  };

  const SingleValue = ({ children, ...props }) => {
    console.log(props);
    return (
      <components.SingleValue {...props}>
        <div className='select-row-container'>
          <div className='select-img-container'>
            <img src={props.data.data.img} alt={props.data.name} className='img' />
          </div>
          {children}
        </div>
      </components.SingleValue>
    )
  };

  const handleChange = (selectedOption) => {
    setSelectedLocation(selectedOption.data);
    dispatch(updateSelectedLocation(selectedOption.data))
  };

  const handleMenuClick = () => {
    navigate(ROUTES.menu)
  }

  useEffect(() => {
    if (!isNull(commonError)) {
      if (commonError.status === 401) {
        dispatch({ type: APP_CONSTANTS.LOGOUT })
      }
    }
  }, [commonError])

  return (
    <>
      {/* <div style={{ display: 'flex', flexDirection: 'column', height: isLogin ? '100vh' : '100vh', overflow: isLogin ? 'auto' : 'hidden' }}> */}
      <div className='app-content-container'>
        {/* {!isLogin && isEmpty(user) && <div className='select-container-parent'>
          <div className='select-container'>
            <Select
              options={LOCATION_LIST.map((item) => ({
                value: item.key,
                label: item.name,
                data: item,
              }))}
              onChange={handleChange}
              placeholder="Select Country"
              components={{ Option, SingleValue }}
              defaultValue={{
                value: DEFAULT_LOCATION.key,
                label: DEFAULT_LOCATION.name,
                data: DEFAULT_LOCATION,
              }}
              isSearchable={false}
              isMulti={false}
              autoFocus={false}
            />
          </div>
        </div>} */}
        {isLogin === true && !isEmpty(user) && <div className='ic-nav-header-row-container'>
          <div className="home-logo-parent-container">
            <div className="home-logo-container">
              <img src={require('./assets/logo_togethra_icon.png')} className="img" alt="logo" />
            </div>
          </div>
          <div className='ic_nav-header-row-item-container'>
            {showMenuOption && <div className='ic-nav-menu' onClick={() => { handleMenuClick() }}>
              <div className='ic-nav-container'>
                <img src={require('./assets/ic_nav_menu.png')} className='img' />
              </div>
              <div className='ic-nav-menu-label'>MENU</div>
            </div>}
            <div className='ic-nav-logout' onClick={() => { dispatch({ type: APP_CONSTANTS.LOGOUT }) }}>
              <div className='ic-nav-logout-img-container'>
                <img src={require('./assets/ic_nav_logout.png')} className='img' />
              </div>
              <div className='ic-nav-logout-label'>LOGOUT</div>
            </div>
          </div>
        </div>}
        {/* {isLogin && user && displaySideBar === true && <CustomSidebar />} */}
        {/* <div className={isLogin ? "content-area" : "content-area-full"}> */}
        <div className={(isLogin === false && isEmpty(user)) ? 'app-route-container-middle-full' : "app-route-container-middle-without-btn"}>
          <Routes>
            <Route path={ROUTES.home} element={<LandingPage />} />
            <Route path={ROUTES.contactUs} element={<ContactUsPage />} />
            <Route path={ROUTES.featureList} element={<FeaturePage />} />
            <Route path={ROUTES.productPricing} element={<PricingPage />} />
            <Route path={ROUTES.privacyPolicy} element={<PrivacyPolicyPage />} />
            <Route path={ROUTES.cookiePolicy} element={<CookiePolicyScreen />} />
            <Route path={ROUTES.tncPage} element={<TermsConditionScreen />} />
            <Route path={ROUTES.businessCreateAccount} element={<BusinessCreateAccount />} />
            <Route path={ROUTES.businessLogin} element={<BusinessLogin />} />
            <Route path={ROUTES.employeeLogin} element={<EmployeeLogin />} />
            <Route path={ROUTES.forgotPassword} element={<ForgotPassword />} />
            <Route path={ROUTES.visitor.checkIn} element={<VisitorCheckIn />} />
            <Route path={ROUTES.employee.selectLocation} element={
              <RouteGuard>
                <EmployeeSelectLocation />
              </RouteGuard>
            } />
            <Route path={ROUTES.updateProfile} element={
              <RouteGuard>
                <UpdateProfile />
              </RouteGuard>
            } />
            <Route path={ROUTES.businessDashboard} element={
              <RouteGuard>
                <BusinessDashboard />
              </RouteGuard>
            } />
            <Route path={ROUTES.employeeDashboard} element={
              <RouteGuard>
                <EmployeeDashboard />
              </RouteGuard>
            } />
            <Route path={ROUTES.menu} element={
              <RouteGuard>
                <MenuPage />
              </RouteGuard>
            } />
            <Route path={ROUTES.employee.list} element={
              <RouteGuard>
                <EmployeeList />
              </RouteGuard>
            } />
            <Route path={ROUTES.employee.add} element={
              <RouteGuard>
                <AddEmployee />
              </RouteGuard>
            } />
            <Route path={ROUTES.employee.detail} element={
              <RouteGuard>
                <EmployeeDetail />
              </RouteGuard>
            } />
            <Route path={ROUTES.attendace.list} element={
              <RouteGuard>
                <AttendanceList />
              </RouteGuard>
            } />
            <Route path={ROUTES.project.list} element={
              <RouteGuard>
                <ProjectList />
              </RouteGuard>
            } />
            <Route path={ROUTES.project.addProject} element={
              <RouteGuard>
                <AddProject />
              </RouteGuard>
            } />
            <Route path={ROUTES.project.detail} element={
              <RouteGuard>
                <ProjectDetail />
              </RouteGuard>
            } />
            <Route path={ROUTES.shift.list} element={
              <RouteGuard>
                <ShiftList />
              </RouteGuard>
            } />
            <Route path={ROUTES.shift.add} element={
              <RouteGuard>
                <AddShift />
              </RouteGuard>
            } />
            <Route path={ROUTES.shift.detail} element={
              <RouteGuard>
                <ShiftDetail />
              </RouteGuard>
            } />
            <Route path={ROUTES.task.list} element={
              <RouteGuard>
                <TaskList />
              </RouteGuard>
            } />
            <Route path={ROUTES.task.add} element={
              <RouteGuard>
                <AddTask />
              </RouteGuard>
            } />
            <Route path={ROUTES.task.detail} element={
              <RouteGuard>
                <TaskDetail />
              </RouteGuard>
            } />
            <Route path={ROUTES.messageList} element={
              <RouteGuard>
                <MessageList />
              </RouteGuard>
            } />
            <Route path={ROUTES.messageChatList} element={
              <RouteGuard>
                <MessageChatList />
              </RouteGuard>
            } />
            <Route path={ROUTES.requests.list} element={
              <RouteGuard>
                <RequestList />
              </RouteGuard>
            } />
            <Route path={ROUTES.requests.add} element={
              <RouteGuard>
                <AddRequest />
              </RouteGuard>
            } />
            <Route path={ROUTES.requests.employeeRequest} element={
              <RouteGuard>
                <EmployeeRequestList />
              </RouteGuard>
            } />
            <Route path={ROUTES.documents.list} element={
              <RouteGuard>
                <DocumentList />
              </RouteGuard>
            } />
            <Route path={ROUTES.documents.add} element={
              <RouteGuard>
                <AddDocument />
              </RouteGuard>
            } />
            <Route path={ROUTES.policies.list} element={
              <RouteGuard>
                <PolicyList />
              </RouteGuard>
            } />
            <Route path={ROUTES.policies.add} element={
              <RouteGuard>
                <AddPolicy />
              </RouteGuard>
            } />
            <Route path={ROUTES.policies.details} element={
              <RouteGuard>
                <PolicyDetail />
              </RouteGuard>
            } />
            <Route path={ROUTES.employee.changePassword} element={
              <RouteGuard>
                <EmployeeChangePassword />
              </RouteGuard>
            } />
            <Route path={ROUTES.admin.userList} element={
              <RouteGuard>
                <AdminUserList />
              </RouteGuard>
            } />
            <Route path={ROUTES.admin.contactUsList} element={
              <RouteGuard>
                <AdminContactUsList />
              </RouteGuard>
            } />
            <Route path={ROUTES.admin.subscriptionList} element={
              <RouteGuard>
                <AdminSubscriptionList />
              </RouteGuard>
            } />
            <Route path={ROUTES.admin.newSubscription} element={
              <RouteGuard>
                <AdminAddSubscription />
              </RouteGuard>
            } />
            <Route path={ROUTES.location.list} element={
              <RouteGuard>
                <LocationListScreen />
              </RouteGuard>
            } />
            <Route path={ROUTES.location.add} element={
              <RouteGuard>
                <AddLocationScreen />
              </RouteGuard>
            } />
            <Route path={ROUTES.location.detail} element={
              <RouteGuard>
                <EditLocationScreen />
              </RouteGuard>
            } />
            <Route path={ROUTES.business.list} element={
              <RouteGuard>
                <BusinessListScreen />
              </RouteGuard>
            } />
            <Route path={ROUTES.business.addBusiness} element={
              <RouteGuard>
                <AddBusinessScreen />
              </RouteGuard>
            } />
            <Route path={ROUTES.assets.list} element={
              <RouteGuard>
                <AssetsList />
              </RouteGuard>
            } />
            <Route path={ROUTES.assets.add} element={
              <RouteGuard>
                <AddAssets />
              </RouteGuard>
            } />
            <Route path={ROUTES.assets.detail} element={
              <RouteGuard>
                <AssetDetails />
              </RouteGuard>
            } />
            <Route path={ROUTES.performance.menu} element={
              <RouteGuard>
                <PeformanceMenuScreen />
              </RouteGuard>
            } />
            <Route path={ROUTES.performance.requestList} element={
              <RouteGuard>
                <PerformanceRequestList />
              </RouteGuard>
            } />
            <Route path={ROUTES.performance.newRequest} element={
              <RouteGuard>
                <PerformanceNewRequest />
              </RouteGuard>
            } />
            <Route path={ROUTES.performance.goalList} element={
              <RouteGuard>
                <PerformanceGoalList />
              </RouteGuard>
            } />
            <Route path={ROUTES.performance.newGoal} element={
              <RouteGuard>
                <PerformanceAddGoal />
              </RouteGuard>
            } />
            <Route path={ROUTES.performance.feedbackList} element={
              <RouteGuard>
                <PerformanceReviewList />
              </RouteGuard>
            } />
            <Route path={ROUTES.performance.goalDetail} element={
              <RouteGuard>
                <PerformanceGoalDetail />
              </RouteGuard>
            } />
            <Route path={ROUTES.employee.clockIn} element={
              <RouteGuard>
                <EmployeeClockIn />
              </RouteGuard>
            } />
            <Route path={ROUTES.subscriptionRenew} element={
              <RouteGuard>
                <SubscriptionRenewScreen />
              </RouteGuard>
            } />
            <Route path={ROUTES.audit.logs} element={
              <RouteGuard>
                <AuditList />
              </RouteGuard>
            } />
            <Route path={ROUTES.audit.newLog} element={
              <RouteGuard>
                <NewAudit />
              </RouteGuard>
            } />
            <Route path={ROUTES.audit.details} element={
              <RouteGuard>
                <AuditDetail />
              </RouteGuard>
            } />
            <Route path={ROUTES.visitor.menu} element={
              <RouteGuard>
                <VisitorOptionMenu />
              </RouteGuard>
            } />
            <Route path={ROUTES.visitor.settings} element={
              <RouteGuard>
                <VisitorSettingScreen />
              </RouteGuard>
            } />
            <Route path={ROUTES.visitor.book} element={
              <RouteGuard>
                <VisitorBook />
              </RouteGuard>
            } />
            <Route path={ROUTES.visitor.entryQR} element={
              <RouteGuard>
                <VisitorQrCode />
              </RouteGuard>
            } />
            <Route path={ROUTES.payroll.menu} element={
              <RouteGuard>
                <PayrollMenu />
              </RouteGuard>
            } />
            <Route path={ROUTES.payroll.taxRules} element={
              <RouteGuard>
                <TaxRuleList />
              </RouteGuard>
            } />
            <Route path={ROUTES.payroll.payslipList} element={
              <RouteGuard>
                <PayslipList />
              </RouteGuard>
            } />
            <Route path={ROUTES.payroll.newPayroll} element={
              <RouteGuard>
                <NewPayslip />
              </RouteGuard>
            } />
            <Route path={ROUTES.payroll.payslipDetail} element={
              <RouteGuard>
                <PayslipDetail />
              </RouteGuard>
            } />
            <Route path={ROUTES.supplies.menu} element={
              <RouteGuard>
                <SuppliesMenu />
              </RouteGuard>
            } />
            <Route path={ROUTES.supplies.merchant.list} element={
              <RouteGuard>
                <MerchantList />
              </RouteGuard>
            } />
            <Route path={ROUTES.supplies.merchant.newMerchant} element={
              <RouteGuard>
                <AddMerchant />
              </RouteGuard>
            } />
            <Route path={ROUTES.supplies.merchant.detail} element={
              <RouteGuard>
                <MerchantDetail />
              </RouteGuard>
            } />
            <Route path={ROUTES.supplies.category.list} element={
              <RouteGuard>
                <SuppliesCategoriesList />
              </RouteGuard>
            } />
            <Route path={ROUTES.supplies.item.catList} element={
              <RouteGuard>
                <SuppliesCatList />
              </RouteGuard>
            } />
            <Route path={ROUTES.supplies.item.list} element={
              <RouteGuard>
                <SuppliesItemList />
              </RouteGuard>
            } />
            <Route path={ROUTES.supplies.item.newItem} element={
              <RouteGuard>
                <AddSuppliesItem />
              </RouteGuard>
            } />
            <Route path={ROUTES.supplies.item.detail} element={
              <RouteGuard>
                <SuppliesItemDetail />
              </RouteGuard>
            } />
            <Route path='*' element={<NotFoundPage />} />
          </Routes>
        </div>
      </div>

    </>
  );
}

export default App;
